import { useState } from "react";
import logo from "../assets/innova-logo.png";
import logotipo from "../assets/innova-logotipo-orange.webp";

import { IoMenuSharp } from "react-icons/io5";
import { FaXmark } from "react-icons/fa6";
import { animateScroll as scroll, scroller } from "react-scroll";

import { FaCircleInfo, FaBoxOpen, FaTags } from "react-icons/fa6";
import { MdOutlineLocalShipping, MdContactMail } from "react-icons/md";
import { SiGooglemaps } from "react-icons/si";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const navItems = [
    { link: "Sobre nosotros", path: "about", icon: <FaCircleInfo className="mr-2" /> },
    { link: "Productos", path: "products", icon: <FaBoxOpen className="mr-2" /> },
    { link: "Precios", path: "prices", icon: <FaTags className="mr-2" /> },
    { link: "Distribuidores", path: "distributors", icon: <MdOutlineLocalShipping className="mr-2 text-xl" /> },
    { link: "Contáctanos", path: "contact", icon: <MdContactMail className="mr-2 text-xl" /> },
  ];

  const handleScrollToSection = (e, path, offset = -100, closeMenu = false) => {
    e.preventDefault();

    if (path === "home") {
      scroll.scrollToTop({
        duration: 500,
        smooth: true,
      });
    } else {
      scroller.scrollTo(path, {
        duration: 500,
        smooth: true,
        offset,
      });
    }

    if (closeMenu) {
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      <nav className="bg-white md:px-14 p-4 w-full border-b mx-auto text-primary fixed top-0 right-0 left-0 z-50">
        <div className="text-lg container mx-auto flex justify-between items-center font-medium">
          <div className="flex space-x-14 items-center">
            <a
              href="#home"
              onClick={(e) => handleScrollToSection(e, "home")}
              className="text-2xl font-semibold flex items-center space-x-3 text-primary"
            >
              <img src={logo} alt="Innova Logo" className="w-10 inline-block items-center" width="40" height="40" />
              <img src={logotipo} alt="Innova Logotipo" className="w-28 inline-block" width="112" height="40" />
            </a>

            <ul className="md:flex space-x-12 hidden">
              {navItems.map(({ link, path, icon }) => (
                <li key={link}>
                  <a
                    href={`#${path}`}
                    onClick={(e) => handleScrollToSection(e, path, -100)}
                    className="flex items-center hover:text-gray-300 cursor-pointer"
                  >
                    {icon}
                    <span>{link}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="focus:outline-none"
              aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
              type="button"
            >
              {isMenuOpen ? (
                <FaXmark className="w-6 h-6 text-primary" />
              ) : (
                <IoMenuSharp className="w-6 h-6 text-primary" />
              )}
            </button>
          </div>
        </div>
      </nav>

      <div
        id="mobile-menu"
        className={`space-y-4 px-4 pt-24 pb-5 border-b border-secondary bg-orange text-xl z-50 ${
          isMenuOpen ? "block fixed top-0 right-0 left-0" : "hidden"
        }`}
      >
        <ul className="space-y-4">
          {navItems.map(({ link, path, icon }) => (
            <li key={link}>
              <a
                href={`#${path}`}
                onClick={(e) => handleScrollToSection(e, path, -80, true)}
                className="flex items-center text-white hover:text-gray-300"
              >
                {icon}
                <span>{link}</span>
              </a>
            </li>
          ))}

          <li>
            <a
              href="https://maps.app.goo.gl/iBWaVR1TRoDHu7ko7"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-white hover:text-gray-300"
              onClick={() => setIsMenuOpen(false)}
            >
              <SiGooglemaps className="mr-2" />
              <span>Ubicación</span>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;